"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timezones = void 0;
exports.timezones = [
    {
        label: `Line Islands Time (Pacific/Kiritimati)`,
        value: "Pacific/Kiritimati",
        name: "Line Islands Time",
        short_name: "LINT",
    },
    {
        label: `Chatham Daylight Time (Pacific/Chatham)`,
        value: "Pacific/Chatham",
        name: "Chatham Daylight Time",
        short_name: "CHADT",
    },
    {
        label: `New Zealand Daylight Time (Pacific/Auckland)`,
        value: "Pacific/Auckland",
        name: "New Zealand Daylight Time",
        short_name: "NZDT",
    },
    {
        label: `Phoenix Islands Time (Pacific/Enderbury)`,
        value: "Pacific/Enderbury",
        name: "Phoenix Islands Time",
        short_name: "PHOT",
    },
    {
        label: `Fiji Summer Time (Pacific/Fiji)`,
        value: "Pacific/Fiji",
        name: "Fiji Summer Time",
        short_name: "FJST",
    },
    {
        label: `Tonga Standard Time (Pacific/Tongatapu)`,
        value: "Pacific/Tongatapu",
        name: "Tonga Standard Time",
        short_name: "TOT",
    },
    {
        label: `Petropavlovsk-Kamchatski Standard Time (Asia/Kamchatka)`,
        value: "Asia/Kamchatka",
        name: "Petropavlovsk-Kamchatski Standard Time",
        short_name: "PETT",
    },
    {
        label: `Pacific/Norfolk`,
        value: "Pacific/Norfolk",
        name: "",
        short_name: "NFT",
    },
    {
        label: `Lord Howe Daylight Time (Australia/Lord_Howe)`,
        value: "Australia/Lord_Howe",
        name: "Lord Howe Daylight Time",
        short_name: "LHDT",
    },
    {
        label: `Australian Eastern Daylight Time (Australia/Sydney)`,
        value: "Australia/Sydney",
        name: "Australian Eastern Daylight Time",
        short_name: "AEDT",
    },
    {
        label: `Solomon Islands Time (Pacific/Guadalcanal)`,
        value: "Pacific/Guadalcanal",
        name: "Solomon Islands Time",
        short_name: "SBT",
    },
    {
        label: `Australian Central Daylight Time (Australia/Adelaide)`,
        value: "Australia/Adelaide",
        name: "Australian Central Daylight Time",
        short_name: "ACDT",
    },
    {
        label: `Australian Eastern Standard Time (Australia/Brisbane)`,
        value: "Australia/Brisbane",
        name: "Australian Eastern Standard Time",
        short_name: "AEST",
    },
    {
        label: `Australian Central Standard Time (Australia/Darwin)`,
        value: "Australia/Darwin",
        name: "Australian Central Standard Time",
        short_name: "ACST",
    },
    {
        label: `Korean Standard Time (Asia/Seoul)`,
        value: "Asia/Seoul",
        name: "Korean Standard Time",
        short_name: "KST",
    },
    {
        label: `Japan Standard Time (Asia/Tokyo)`,
        value: "Asia/Tokyo",
        name: "Japan Standard Time",
        short_name: "JST",
    },
    {
        label: `Hong Kong Standard Time (Asia/Hong_Kong)`,
        value: "Asia/Hong_Kong",
        name: "Hong Kong Standard Time",
        short_name: "HKT",
    },
    {
        label: `Malaysia Time (Asia/Kuala_Lumpur)`,
        value: "Asia/Kuala_Lumpur",
        name: "Malaysia Time",
        short_name: "MYT",
    },
    {
        label: `Philippine Standard Time (Asia/Manila)`,
        value: "Asia/Manila",
        name: "Philippine Standard Time",
        short_name: "PHT",
    },
    {
        label: `China Standard Time (Asia/Shanghai)`,
        value: "Asia/Shanghai",
        name: "China Standard Time",
        short_name: "CST",
    },
    {
        label: `Singapore Standard Time (Asia/Singapore)`,
        value: "Asia/Singapore",
        name: "Singapore Standard Time",
        short_name: "SGT",
    },
    {
        label: `Taipei Standard Time (Asia/Taipei)`,
        value: "Asia/Taipei",
        name: "Taipei Standard Time",
        short_name: "TST",
    },
    {
        label: `Australian Western Standard Time (Australia/Perth)`,
        value: "Australia/Perth",
        name: "Australian Western Standard Time",
        short_name: "AWST",
    },
    {
        label: `Indochina Time (Asia/Bangkok)`,
        value: "Asia/Bangkok",
        name: "Indochina Time",
        short_name: "ICT",
    },
    {
        label: `Indochina Time (Asia/Ho_Chi_Minh)`,
        value: "Asia/Ho_Chi_Minh",
        name: "Indochina Time",
        short_name: "ICT",
    },
    {
        label: `Western Indonesia Time (Asia/Jakarta)`,
        value: "Asia/Jakarta",
        name: "Western Indonesia Time",
        short_name: "WIB",
    },
    {
        label: `Myanmar Time (Asia/Rangoon)`,
        value: "Asia/Rangoon",
        name: "Myanmar Time",
        short_name: "MMT",
    },
    {
        label: `Bangladesh Standard Time (Asia/Dhaka)`,
        value: "Asia/Dhaka",
        name: "Bangladesh Standard Time",
        short_name: "BST",
    },
    {
        label: `Nepal Time (Asia/Kathmandu)`,
        value: "Asia/Kathmandu",
        name: "Nepal Time",
        short_name: "NPT",
    },
    {
        label: `India Standard Time (Asia/Colombo)`,
        value: "Asia/Colombo",
        name: "India Standard Time",
        short_name: "IST",
    },
    {
        label: `India Standard Time (Asia/Kolkata)`,
        value: "Asia/Kolkata",
        name: "India Standard Time",
        short_name: "IST",
    },
    {
        label: `Pakistan Standard Time (Asia/Karachi)`,
        value: "Asia/Karachi",
        name: "Pakistan Standard Time",
        short_name: "PKT",
    },
    {
        label: `Uzbekistan Standard Time (Asia/Tashkent)`,
        value: "Asia/Tashkent",
        name: "Uzbekistan Standard Time",
        short_name: "UZT",
    },
    {
        label: `Yekaterinburg Standard Time (Asia/Yekaterinburg)`,
        value: "Asia/Yekaterinburg",
        name: "Yekaterinburg Standard Time",
        short_name: "YEKT",
    },
    {
        label: `Afghanistan Time (Asia/Kabul)`,
        value: "Asia/Kabul",
        name: "Afghanistan Time",
        short_name: "AFT",
    },
    {
        label: `Azerbaijan Standard Time (Asia/Baku)`,
        value: "Asia/Baku",
        name: "Azerbaijan Standard Time",
        short_name: "AZT",
    },
    {
        label: `Gulf Standard Time (Asia/Dubai)`,
        value: "Asia/Dubai",
        name: "Gulf Standard Time",
        short_name: "GST",
    },
    {
        label: `Georgia Standard Time (Asia/Tbilisi)`,
        value: "Asia/Tbilisi",
        name: "Georgia Standard Time",
        short_name: "GET",
    },
    {
        label: `Armenia Standard Time (Asia/Yerevan)`,
        value: "Asia/Yerevan",
        name: "Armenia Standard Time",
        short_name: "AMT",
    },
    {
        label: `Iran Standard Time (Asia/Tehran)`,
        value: "Asia/Tehran",
        name: "Iran Standard Time",
        short_name: "IRST",
    },
    {
        label: `East Africa Time (Africa/Nairobi)`,
        value: "Africa/Nairobi",
        name: "East Africa Time",
        short_name: "EAT",
    },
    {
        label: `Arabian Standard Time (Asia/Baghdad)`,
        value: "Asia/Baghdad",
        name: "Arabian Standard Time",
        short_name: "AST",
    },
    {
        label: `Arabian Standard Time (Asia/Kuwait)`,
        value: "Asia/Kuwait",
        name: "Arabian Standard Time",
        short_name: "AST",
    },
    {
        label: `Arabian Standard Time (Asia/Riyadh)`,
        value: "Asia/Riyadh",
        name: "Arabian Standard Time",
        short_name: "AST",
    },
    {
        label: `Europe/Istanbul`,
        value: "Europe/Istanbul",
        name: "",
        short_name: "TRT",
    },
    {
        label: `Moscow Standard Time (Europe/Minsk)`,
        value: "Europe/Minsk",
        name: "Moscow Standard Time",
        short_name: "MSK",
    },
    {
        label: `Moscow Standard Time (Europe/Moscow)`,
        value: "Europe/Moscow",
        name: "Moscow Standard Time",
        short_name: "MSK",
    },
    {
        label: `Eastern European Standard Time (Africa/Cairo)`,
        value: "Africa/Cairo",
        name: "Eastern European Standard Time",
        short_name: "EET",
    },
    {
        label: `South Africa Standard Time (Africa/Johannesburg)`,
        value: "Africa/Johannesburg",
        name: "South Africa Standard Time",
        short_name: "SAST",
    },
    {
        label: `Eastern European Standard Time (Asia/Beirut)`,
        value: "Asia/Beirut",
        name: "Eastern European Standard Time",
        short_name: "EET",
    },
    {
        label: `Israel Standard Time (Asia/Jerusalem)`,
        value: "Asia/Jerusalem",
        name: "Israel Standard Time",
        short_name: "IST",
    },
    {
        label: `Eastern European Standard Time (Europe/Athens)`,
        value: "Europe/Athens",
        name: "Eastern European Standard Time",
        short_name: "EET",
    },
    {
        label: `Eastern European Standard Time (Europe/Bucharest)`,
        value: "Europe/Bucharest",
        name: "Eastern European Standard Time",
        short_name: "EET",
    },
    {
        label: `Eastern European Standard Time (Europe/Helsinki)`,
        value: "Europe/Helsinki",
        name: "Eastern European Standard Time",
        short_name: "EET",
    },
    {
        label: `Central European Standard Time (Africa/Algiers)`,
        value: "Africa/Algiers",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Western European Standard Time (Africa/Casablanca)`,
        value: "Africa/Casablanca",
        name: "Western European Standard Time",
        short_name: "WET",
    },
    {
        label: `Central European Standard Time (Europe/Amsterdam)`,
        value: "Europe/Amsterdam",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Central European Standard Time (Europe/Berlin)`,
        value: "Europe/Berlin",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Central European Standard Time (Europe/Brussels)`,
        value: "Europe/Brussels",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Central European Standard Time (Europe/Paris)`,
        value: "Europe/Paris",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Central European Standard Time (Europe/Prague)`,
        value: "Europe/Prague",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Central European Standard Time (Europe/Rome)`,
        value: "Europe/Rome",
        name: "Central European Standard Time",
        short_name: "CET",
    },
    {
        label: `Irish Standard Time (Europe/Dublin)`,
        value: "Europe/Dublin",
        name: "Irish Standard Time",
        short_name: "IST",
    },
    {
        label: `Western European Standard Time (Europe/Lisbon)`,
        value: "Europe/Lisbon",
        name: "Western European Standard Time",
        short_name: "WET",
    },
    {
        label: `Greenwich Mean Time (Europe/London)`,
        value: "Europe/London",
        name: "Greenwich Mean Time",
        short_name: "GMT",
    },
    {
        label: `Greenwich Mean Time (GMT)`,
        value: "GMT",
        name: "Greenwich Mean Time",
        short_name: "GMT",
    },
    {
        label: `East Greenland Standard Time (America/Scoresbysund)`,
        value: "America/Scoresbysund",
        name: "East Greenland Standard Time",
        short_name: "EGT",
    },
    {
        label: `Azores Standard Time (Atlantic/Azores)`,
        value: "Atlantic/Azores",
        name: "Azores Standard Time",
        short_name: "AZOT",
    },
    {
        label: `Cape Verde Standard Time (Atlantic/Cape_Verde)`,
        value: "Atlantic/Cape_Verde",
        name: "Cape Verde Standard Time",
        short_name: "CVT",
    },
    {
        label: `South Georgia Time (Atlantic/South_Georgia)`,
        value: "Atlantic/South_Georgia",
        name: "South Georgia Time",
        short_name: "GST",
    },
    {
        label: `Argentina Standard Time (America/Argentina/Buenos_Aires)`,
        value: "America/Argentina/Buenos_Aires",
        name: "Argentina Standard Time",
        short_name: "ART",
    },
    {
        label: `Chile Summer Time (America/Santiago)`,
        value: "America/Santiago",
        name: "Chile Summer Time",
        short_name: "CLST",
    },
    {
        label: `Brasilia Standard Time (America/Sao_Paulo)`,
        value: "America/Sao_Paulo",
        name: "Brasilia Standard Time",
        short_name: "BRT",
    },
    {
        label: `Newfoundland Standard Time (America/St_Johns)`,
        value: "America/St_Johns",
        name: "Newfoundland Standard Time",
        short_name: "NST",
    },
    {
        label: `Venezuela Time (America/Caracas)`,
        value: "America/Caracas",
        name: "Venezuela Time",
        short_name: "VET",
    },
    {
        label: `Atlantic Standard Time (America/Halifax)`,
        value: "America/Halifax",
        name: "Atlantic Standard Time",
        short_name: "AST",
    },
    {
        label: `Atlantic Standard Time (America/Puerto_Rico)`,
        value: "America/Puerto_Rico",
        name: "Atlantic Standard Time",
        short_name: "AST",
    },
    {
        label: `Atlantic Standard Time (Atlantic/Bermuda)`,
        value: "Atlantic/Bermuda",
        name: "Atlantic Standard Time",
        short_name: "AST",
    },
    {
        label: `Colombia Standard Time (America/Bogota)`,
        value: "America/Bogota",
        name: "Colombia Standard Time",
        short_name: "COT",
    },
    {
        label: `Eastern Standard Time (America/Indiana/Indianapolis)`,
        value: "America/Indiana/Indianapolis",
        name: "Eastern Standard Time",
        short_name: "EST",
    },
    {
        label: `Peru Standard Time (America/Lima)`,
        value: "America/Lima",
        name: "Peru Standard Time",
        short_name: "PET",
    },
    {
        label: `Eastern Standard Time (America/New_York)`,
        value: "America/New_York",
        name: "Eastern Standard Time",
        short_name: "EST",
    },
    {
        label: `Eastern Standard Time (America/Panama)`,
        value: "America/Panama",
        name: "Eastern Standard Time",
        short_name: "EST",
    },
    {
        label: `Central Standard Time (America/Chicago)`,
        value: "America/Chicago",
        name: "Central Standard Time",
        short_name: "CST",
    },
    {
        label: `Central Standard Time (America/El_Salvador)`,
        value: "America/El_Salvador",
        name: "Central Standard Time",
        short_name: "CST",
    },
    {
        label: `Central Standard Time (America/Mexico_City)`,
        value: "America/Mexico_City",
        name: "Central Standard Time",
        short_name: "CST",
    },
    {
        label: `Central Standard Time (America/Regina)`,
        value: "America/Regina",
        name: "Central Standard Time",
        short_name: "CST",
    },
    {
        label: `Mountain Standard Time (America/Denver)`,
        value: "America/Denver",
        name: "Mountain Standard Time",
        short_name: "MST",
    },
    {
        label: `Mexican Pacific Standard Time (America/Mazatlan)`,
        value: "America/Mazatlan",
        name: "Mexican Pacific Standard Time",
        short_name: "MST",
    },
    {
        label: `Mountain Standard Time (America/Phoenix)`,
        value: "America/Phoenix",
        name: "Mountain Standard Time",
        short_name: "MST",
    },
    {
        label: `Pacific Standard Time (America/Los_Angeles)`,
        value: "America/Los_Angeles",
        name: "Pacific Standard Time",
        short_name: "PST",
    },
    {
        label: `Pacific Standard Time (America/Tijuana)`,
        value: "America/Tijuana",
        name: "Pacific Standard Time",
        short_name: "PST",
    },
    {
        label: `Pitcairn Time (Pacific/Pitcairn)`,
        value: "Pacific/Pitcairn",
        name: "Pitcairn Time",
        short_name: "PST",
    },
    {
        label: `Alaska Standard Time (America/Anchorage)`,
        value: "America/Anchorage",
        name: "Alaska Standard Time",
        short_name: "AKST",
    },
    {
        label: `Gambier Time (Pacific/Gambier)`,
        value: "Pacific/Gambier",
        name: "Gambier Time",
        short_name: "GAMT",
    },
    {
        label: `Marquesas Time (Pacific/Marquesas)`,
        value: "Pacific/Marquesas",
        name: "Marquesas Time",
        short_name: "MART",
    },
    {
        label: `Hawaii-Aleutian Standard Time (America/Adak)`,
        value: "America/Adak",
        name: "Hawaii-Aleutian Standard Time",
        short_name: "HAST",
    },
    {
        label: `Hawaii-Aleutian Standard Time (Pacific/Honolulu)`,
        value: "Pacific/Honolulu",
        name: "Hawaii-Aleutian Standard Time",
        short_name: "HAST",
    },
    {
        label: `Niue Time (Pacific/Niue)`,
        value: "Pacific/Niue",
        name: "Niue Time",
        short_name: "NUT",
    },
    {
        label: `Samoa Standard Time (Pacific/Pago_Pago)`,
        value: "Pacific/Pago_Pago",
        name: "Samoa Standard Time",
        short_name: "SST",
    },
];
